import React from 'react';
import styles from './SpecsPage.module.css';

const SpecsPage = () => {
    return (
        <div className={styles.pageWrapper}>
            <header className={styles.hero}>
                <div className={styles.container}>
                    <p className={styles.eyebrow}>Format Specs & Recommendations</p>
                    <h1 className={styles.title}>Launch your creatives with confidence on Neoo Search</h1>
                    <p className={styles.description}>
                        Help customers discover your brand across the Neoo Search ecosystem. Promote your business using flexible formats,
                        strategic placements, and goal-driven campaigns designed to increase visibility and engagement.
                    </p>
                </div>
            </header>

            <main className={styles.container}>
                <section className={styles.introCard}>
                    <p>
                        The <strong>Neoo Search Creatives Guide</strong> provides clear design specifications and technical requirements
                        for each format, including ad dimensions, file sizes, character limits, and best practices to ensure optimal performance across Neoo Search platforms.
                        Enhance your presence by showcasing your NeooCard profile and Business Listing effectively.
                    </p>
                </section>

                <div className={styles.specsGrid}>

                    <section className={styles.specCard}>
                        <div className={styles.cardHeader}>
                            <div className={styles.icon}><i className="fa fa-address-card"></i></div>
                            <h2>NeooCard Profile Specifications</h2>
                        </div>
                        <ul className={styles.specList}>
                            <li><span>Profile photo</span> <strong>120×120 pixels, max 1 MB (JPG, PNG)</strong></li>
                            <li><span>Profile banner image</span> <strong>1000×400 pixels, max 1 MB (JPG, PNG)</strong></li>
                            <li><span>About Us</span> <strong>Up to 150 words</strong></li>
                            <li><span>Services</span> <strong>Up to 5 categories</strong></li>
                            <li><span>Products</span> <strong>Up to 5 items</strong></li>
                            <li><span>Product image size</span> <strong>560×300 pixels, max 500 KB (JPG, PNG)</strong></li>
                            <li><span>Product description</span> <strong>Up to 50 words each</strong></li>
                            <li><span>Video profile</span> <strong>1 link</strong></li>
                            <li><span>PDF profile</span> <strong>Up to 3 files, max 3 MB each</strong></li>
                        </ul>
                    </section>

                    <section className={styles.specCard}>
                        <div className={styles.cardHeader}>
                            <div className={styles.icon}><i className="fa fa-building"></i></div>
                            <h2>Business Page Specifications</h2>
                        </div>
                        <ul className={styles.specList}>
                            <li><span>Logo</span> <strong>120×120 pixels, max 500 KB (JPG, PNG)</strong></li>
                            <li><span>Page banner image</span> <strong>982×283 pixels, max 1 MB (JPG, PNG)</strong></li>
                            <li><span>About Us</span> <strong>Up to 150 words</strong></li>
                            <li><span>Services</span> <strong>Up to 5 categories</strong></li>
                            <li><span>Search keywords</span> <strong>Up to 6</strong></li>
                            <li><span>Gallery</span> <strong>Up to 5 images</strong></li>
                            <li><span>Gallery image size</span> <strong>640×428 pixels, max 500 KB (JPG, PNG)</strong></li>
                            <li><span>Gallery image description</span> <strong>Up to 50 words each</strong></li>
                            <li className={styles.nestedTitle}>Post Updates:</li>
                            <li className={styles.nested}><span>Title</span> <strong>Up to 10 words</strong></li>
                            <li className={styles.nested}><span>Description</span> <strong>Up to 60 words</strong></li>
                            <li className={styles.nested}><span>Attachment image</span> <strong>982×283 pixels, max 500 KB (JPG, PNG)</strong></li>
                            <li><span>Social media links</span> <strong>Up to 3</strong></li>
                        </ul>
                    </section>

                </div>
            </main>
        </div>
    );
};

export default SpecsPage;